// Card molecule component
export const Card = ({
  children,
  className = "",
  hoverable = false,
  ...props
}) => {
  const hoverClass = hoverable
    ? "hover:shadow-lift hover:-translate-y-1.5 transition-all duration-300"
    : "";

  return (
    <div
      className={`bg-white rounded-2xl shadow-soft border border-terracotta-100/60 ${hoverClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
